require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./beaverton-mountain-bike-team.json") })
        }
      }, "path---beaverton-mountain-bike-team");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---beaverton-mountain-bike-team!./.cache/json/beaverton-mountain-bike-team.json
// module id = 840
// module chunks = 231608221292675